import React, { useState } from 'react'
import DeliveryFeeCom from './DeliveryFeeCom'
import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'


function DeliveryFees({meta}) {  
    const [pagination,setPagination]=useState({
      "page": 1,
      "limit": 5,
      "sortOrder": "desc",
      "filter": {}
    })
  
    const handlePagination=(data)=>{
      // console.log(data);
      
      if (data.clearPagination) {
        setPagination(data.clearPagination)
        return
      }
      
      setPagination((prev)=>{
          let copyfilter={...prev.filter}
          // copyfilter[]
         
          if (data.filter) {
            // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
            // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
            
            if (copyfilter[Object.keys(data.filter)[0]]) {
              copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
              
            }else{
  
              copyfilter={...data?.filter,...copyfilter}
            }
          
          }
         
    
          return{
            page:data.page?data.page:prev.page,
            limit:data.limit?data.limit:prev.limit,
            sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
            filter:copyfilter
          }
    
        })
      }

      

    
 
  

  return (
    <>
        <CommonLayout />
        <div className={`flex w-full justify-between flex-wrap p-[2rem]`}>
          <div>
            <p className={`text-[1.3rem] text-[--text-color3] capitalize`}>
              { "All Stores"}
              <span className={`text-[0.9rem] text-[--color-tbl-data] ml-3`}>
              </span>
            </p>
          </div>

          <div className="flex gap-2">
          </div>          
        </div>
        <DeliveryFeeCom pagination={pagination} handlePagination={handlePagination}/>
       
          
    </>
  )
}

export default DeliveryFees
// import React, { useState } from 'react'
// import RightCard from './RightCard'
// import Styles from './Styles.module.css'
// import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'
// import DeliveryFeeCom from './DeliveryFeeCom'
// import AddVehicleCom from './AddVehicleCom'



// function DeliveryFees() {
//   const [activeToggle, setActiveToggle] = useState("Add Delivery Fee");
//   const toggleJson = [
//     "Add Delivery Fee",
//     "Add Vehicle",
    
//   ];
//   const [rightTabs, setRightTabs] = useState([
//     {
//       tab: "Delivery Fee",
//       isActive: true,
//     },
//     {
//       tab: "Vehicle",
//       isActive: false
//     },
//   ])
//   return (<>
//     <div className={[`${Styles.dispatchContainer}`]}>

//       <div className={Styles.center}>   
       
//         <div style={{height:"100%",padding:"1rem"}}>
//           <CommonLayout />
//           <TogglesList
//         data={toggleJson}
//         active={activeToggle}
//         setActiveToggle={setActiveToggle}
//       />
//       {activeToggle === "Add Delivery Fee" && <DeliveryFeeCom/>}
//       {activeToggle === "Add Vehicle" && <AddVehicleCom />}
          
//        </div>
        
//       </div>

//       <div className="right">
//         <RightCard tabs={rightTabs} setTab={setRightTabs} sx={{ borderTopLeftRadius: "10px" }} />
//       </div>

//     </div>
//   </>
//   )
// }

// export default DeliveryFees

// const TogglesList = ({ data, active, setActiveToggle }) => {
//   return (
//     <div style={{ position: "relative" }}>
//       <div className={Styles.tabContainer}>
//         {data?.map((item) => (
//           <p
//             className={active === item ? Styles.tabActive : Styles.tabP}
//             onClick={() => setActiveToggle(item)}
//           >
//             {item.toUpperCase()}
//           </p>
//         ))}
//       </div>
//       <hr
//         style={{
//           position: "absolute",
//           bottom: "0",
//           width: "90%",
//           marginLeft: "2rem",
//           //   marginRight: "2rem",
//         }}
//       />
//     </div>
//   );
// };
